import React from 'react';

const ContactCTA = ({
  heroImg,
  heroAlt,
  ctaText,
  bodyText,
  bgColor,
}) => (
  <div
    class={`block rounded-lg ${bgColor || 'bg-green-700'}`}>
    <div class="flex flex-wrap items-center">
      <div class="block w-full shrink-0 grow-0 basis-auto lg:flex lg:w-6/12 xl:w-4/12">
        <img src={heroImg} alt={heroAlt}
          class="w-full rounded-t-lg lg:rounded-tr-none lg:rounded-bl-lg" />
      </div>
      <div class="w-full shrink-0 grow-0 basis-auto lg:w-6/12 xl:w-8/12">
        <div class="px-6 py-12 md:px-12">
          <h2 class="text-white mb-6 pb-2 text-3xl font-bold">
            {ctaText}
          </h2>
          <p className="mb-6 pb-2 text-white" dangerouslySetInnerHTML={{ __html: bodyText }} />
        </div>
      </div>
    </div>
  </div>
);

export default ContactCTA;